import classnames from 'classnames';
import React, { useCallback, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';

import { Icon } from '../icon/Icon';
import { Add, Delete } from '../icons';
import { ProfilePicture } from './ProfilePicture';
import styles from './ProfilePicture.module.scss';
import { MimeType } from '../../constants/MimeType';

interface DropzonePictureProps {
    setProfilePicture: (files: File[]) => void;
    removeProfilePicture: () => void;
    file?: File | undefined;
    profilePicture?: Buffer;
    initials?: string;
    testId?: string;
    disabled?: boolean;
}

export const DropzonePicture: React.FC<DropzonePictureProps> = ({
    disabled = false,
    setProfilePicture,
    removeProfilePicture,
    profilePicture,
    file,
    initials,
    testId
}) => {
    const onDrop = useCallback((acceptedFiles: File[]) => setProfilePicture(acceptedFiles), [setProfilePicture]);
    const onMinusClick = useCallback(() => removeProfilePicture(), [removeProfilePicture]);

    const minusButtonVisible = useMemo(() => !disabled && !!profilePicture, [disabled, profilePicture]);

    const { getRootProps, getInputProps } = useDropzone({
        disabled: disabled,
        maxFiles: 1,
        accept: {
            [MimeType.PNG]: [],
            [MimeType.JPEG]: [],
            [MimeType.WEBP]: [],
            [MimeType.TIFF]: []
        },
        onDrop,
        maxSize: 2097152
    });

    return (
        <div className={classnames(styles.dropzoneWrapper, { [styles.dropzoneDisabled]: disabled })}>
            <div {...getRootProps()} className={styles.dropzone} data-testid={`${testId}-dropzone-picture-wrapper`}>
                <input {...getInputProps()} />
                <ProfilePicture profilePicture={profilePicture} file={file} initials={initials} />
                {!disabled && <div className={styles.updateProfilePictureAdd}><Icon icon={Add} /></div>}
            </div>
            {minusButtonVisible && <div className={styles.updateProfilePictureRemove} onClick={onMinusClick}><Icon icon={Delete} /></div>}
        </div>
    );
};
